"use strict";

exports.__esModule = true;
exports.default = void 0;

var Cache =
/*#__PURE__*/
function () {
  function Cache(_ref) {
    var ttl = _ref.ttl;
    this.ttl = ttl;
    this._cache = new Map();
  }

  var _proto = Cache.prototype;

  _proto.get = function get(key) {
    var item = this._cache.get(key);

    if (item == null) {
      return undefined;
    }

    var needsRefresh = Date.now() - item.timestamp > this.ttl;
    return {
      node: item.value,
      needsRefresh: needsRefresh
    };
  };

  _proto.set = function set(key, value) {
    this._cache.set(key, {
      timestamp: Date.now(),
      value: value
    });
  };

  return Cache;
}();

exports.default = Cache;